import { createContext } from 'react';
import { AccessibleProduct } from '../services/account.service';
import { ResolvedProductBranding } from '../services/product-branding.service';

export interface ProductContextValue {
  selectedProductId: number | null;
  setSelectedProduct: (id: number | null) => void;
  accessibleProducts: AccessibleProduct[];
  isGlobalProductScope: boolean;
  activeBranding: ResolvedProductBranding | null;
}

export const ProductContext = createContext<ProductContextValue>({
  selectedProductId: null,
  setSelectedProduct: () => {},
  accessibleProducts: [],
  isGlobalProductScope: false,
  activeBranding: null,
});
